import {oidcServiceUrl, oidcClientId} from "../infrastructure/config";

export const oidcUserKey = `oidc.user:${oidcServiceUrl}:${oidcClientId}`;
